export default function AIServicesSection() {
  return (
    <section className="bg-white py-16 border-t border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-medium mb-4">
            <span className="bg-teal-600 text-white px-2 py-0.5 rounded-full text-xs mr-2">New</span>
            AI-Powered
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Never miss a patient call</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Missed calls can mean missed patients. Let our AI answering services cover the phones so you're free to focus on patient care.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Small Practice Card */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 text-center shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-teal-100 to-cyan-100 rounded-2xl flex items-center justify-center">
              <img
                alt="Small practice"
                className="w-20 h-20 object-cover rounded-xl"
                src="https://readdy.ai/api/search-image?query=Small%20medical%20clinic%20reception%20desk%20with%20friendly%20receptionist%20answering%20phone%20calls%2C%20modern%20medical%20office%20interior%20with%20clean%20white%20and%20teal%20design%2C%20professional%20healthcare%20customer%20service&width=300&height=300&seq=small-practice&orientation=squarish"
              />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              For small<br />practices
            </h3>
            <a
              href="/ai-receptionist"
              className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 bg-teal-600 hover:bg-teal-700 text-white shadow-sm hover:shadow-md focus:ring-teal-500 px-4 py-2 text-sm whitespace-nowrap"
            >
              Learn more
            </a>
          </div>

          {/* Large Hospital Card */}
          <div className="bg-white rounded-2xl border border-gray-200 p-8 text-center shadow-sm hover:shadow-lg transition-shadow">
            <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-teal-100 to-cyan-100 rounded-2xl flex items-center justify-center">
              <img
                alt="Large hospitals"
                className="w-20 h-20 object-cover rounded-xl"
                src="https://readdy.ai/api/search-image?query=Large%20hospital%20reception%20area%20with%20multiple%20staff%20members%20managing%20patient%20appointments%20and%20calls%2C%20modern%20healthcare%20facility%20with%20advanced%20technology%20systems%2C%20professional%20medical%20administration&width=300&height=300&seq=large-hospital&orientation=squarish"
              />
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              For large<br />hospitals
            </h3>
            <a
              href="/ai-hospital"
              className="inline-flex items-center justify-center font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 bg-teal-600 hover:bg-teal-700 text-white shadow-sm hover:shadow-md focus:ring-teal-500 px-4 py-2 text-sm whitespace-nowrap"
            >
              Learn more
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}